import CategoryNorms from './CategoryNorms';
export default CategoryNorms;
